<script setup lang="ts">

import {faSpinnerThird} from "@fortawesome/pro-solid-svg-icons";
import type {HTMLAttributes} from "vue";
import {Button} from "@/shared/components/ui/button";
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";
import {useI18n} from "vue-i18n";

interface Props {
  loading: boolean
  disabled?: boolean
  icon?: IconDefinition
  class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
})
const {t} = useI18n()

</script>

<template>
  <Button type="submit" :busy="loading" :disabled="disabled || loading" :class="props.class" :icon="icon" :busy-icon="faSpinnerThird">
    <slot v-if="$slots.default"/>
    <span v-else>{{ t('shared.common.save') }}</span>
  </Button>
</template>

<style scoped>

</style>